/**
 */

import { appendEntityToConversation } from './chat-entity-insertion.helper'
import type {
  AddAgentReportEntityPayload,
  AgentReportEntity,
  ChatMessageEntity,
} from './chat-message-entity.interface'
import type { ChatState } from './chat-state.interface'

export const handleAddAgentReportEntity = (
  state: ChatState,
  payload: AddAgentReportEntityPayload
): void => {
  const existing = state.messageEntities[payload.eventId]
  if (existing) {
    state.messageEntities[existing.id] = buildReplacementReport(existing, payload)
    state.lastReportCompletedAt = Date.now()
    return
  }
  createNewReportEntity(state, payload)
}

const buildReplacementReport = (
  existing: ChatMessageEntity,
  payload: AddAgentReportEntityPayload
): AgentReportEntity => {
  const resolved = payload.reportContent || existing.streamingContent || existing.content || ''
  return {
    id: existing.id,
    conversationId: existing.conversationId,
    timestamp: existing.timestamp,
    turnStartedAt: payload.turnStartedAt ?? existing.turnStartedAt,
    stableKey: existing.stableKey,
    type: 'agent-report',
    content: resolved,
    reportContent: resolved,
    agentId: payload.agentId,
    agentName: payload.agentName,
    reportId: payload.reportId,
    reportVersion: payload.reportVersion,
    isMasterArtifact: payload.isMasterArtifact,
    reportFormat: payload.reportFormat,
    shouldAutoOpen: true,
    participant: { id: payload.agentId, name: payload.agentName },
    isPending: false,
    isStreaming: false,
    streamingContent: '',
  }
}

const createNewReportEntity = (state: ChatState, payload: AddAgentReportEntityPayload): void => {
  const {
    conversationId,
    eventId,
    agentId,
    agentName,
    reportContent,
    reportVersion,
    reportId,
    isMasterArtifact,
    reportFormat,
    turnStartedAt,
  } = payload
  const now = new Date().toISOString()
  const entity: AgentReportEntity = {
    id: eventId,
    conversationId,
    type: 'agent-report',
    content: reportContent,
    timestamp: turnStartedAt ?? now,
    turnStartedAt: turnStartedAt ?? now,
    agentId,
    agentName,
    reportId,
    reportContent,
    reportVersion,
    participant: { id: agentId, name: agentName },
    isPending: false,
    isStreaming: false,
    streamingContent: '',
    shouldAutoOpen: true,
    isMasterArtifact,
    reportFormat,
  }
  appendEntityToConversation({ state, conversationId, entity })
  state.lastReportCompletedAt = Date.now()
}
